/**
 * Modelo de representação de parâmetro de requisição para o charon
 * @export
 * @class RequisicaoParametroCharon
 */
export class RequisicaoParametroCharon {
  constructor(key?: string, value?: any) {
      this.key = key;
      this.value = value;
  }

  key: string;
  value: any
}
